import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MenuState } from '../reducers';

export const selectMenuState = createFeatureSelector<MenuState>('menu');

export const selectMenuLoading = createSelector(
  selectMenuState,
  (state: MenuState) => state.loading
);

export const selectMenu = createSelector(
  selectMenuState,
  (state: MenuState) => state?.menu
);

export const selectMenuList = createSelector(
  selectMenuState,
  (state: MenuState) => state.menuList
);

export const selectMenuId = createSelector(
  selectMenuState,
  (state: MenuState) => state.menuId
);

export const selectMenuError = createSelector(
  selectMenuState,
  (state: MenuState) => state.error
);
